















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as setting_types from "@/store/constants/setting_types";
import VipBenefit from "./VipBenefit.vue";
import VipButton from "@/components/VipButton/VipButton.vue";
import { goToVip } from "@/utils/router_helper";
import {payByAny} from "@/services/payment/payment_check/payment_check_logic";
import { OfferSituation } from "@/services/offer/offer_handle";
import { VIP_SITUATION } from "@/utils/log_event/event_const";
import WebSessionStorageWorker from "@/utils/nativeStorage/web_session_storage";

@Component({
  components: { VipBenefit, VipButton }
})
export default class BuyVipEntrance extends Vue {
  @Getter(setting_types.GETTER_SERVICE_OFFERS)
  private serviceOffer: any;
  get offer() {
    return this.serviceOffer && this.serviceOffer[0];
  }
  private buyVip() {
    try {
      payByAny({ offer: this.offer, situation: OfferSituation.tab5_vip });
    } catch (error) {
      //
    }
  }
  private goToVIP() {
    WebSessionStorageWorker.set("is_has_show_vip_cell", "show");
    goToVip("tab5_more", VIP_SITUATION.tab5);
  }
}
